module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('center', [_c('form', {
    staticClass: "navbar-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "catalog"
    }
  }, _vm._l((_vm.catalog), function(option) {
    return _c('option', {
      domProps: {
        "value": option.text
      }
    }, [_vm._v("\n                            " + _vm._s(option.text) + "\n                        ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "請輸入產品名稱"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.ProductSearch()
      }
    }
  }, [_vm._v("查詢")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, _vm._l((_vm.productList), function(item, index) {
    return _c('div', {
      staticClass: "col-md-3 col-sm-4 col-xs-6"
    }, [_c('div', {
      staticClass: "product_box"
    }, [_c('figure', {
      staticClass: "pic justify"
    }, [_c('a', {
      attrs: {
        "href": '/product/' + item.id
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + item.imageM
      }
    })])]), _vm._v(" "), _c('center', [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.price > 0) ? _c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.price))]) : _vm._e(), _vm._v(" "), (item.price > 0 && item.point) ? _c('span', {
      staticClass: "points"
    }, [_vm._v(_vm._s(item.point) + "點")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "addcart btn btn-default i80_btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.addToCart(item)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-shopping-cart",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" 加入購物車\n                        ")])])], 1)])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/product"
    }
  }, [_vm._v("商品")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("商品列表")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd2b5442"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product.vue
// module id = 316
// module chunks = 1